import React from "react";
import { Translate } from "../../../../language";
import CardList from "../../../../utils/components/CardList/CardList";
import Botton from "../../../../utils/components/Button/Button";
import InputSearch from "../../../../utils/components/InputSearch/InputSearch";
import "./Wineries.css";
import cardStyle from ".././CardListWineries.module.css";
import { useHistory } from "react-router-dom";
import TitleSVG from "../../../../utils/components/TitleSVG/TitleSVG";
import { WineryIcon } from "../../../../assets/icons";
const Wineries = ({
  setCodeName,
  codeName,
  hadleClick = () => { },
  wineriesList = [] }) => {
  const history = useHistory()
  return (
    <>
      <TitleSVG
        Icon={WineryIcon}
        titleHighlight={Translate("wineries", "es")}
      />
      <div className="content-create-wineries">
        <div className="content-principal-wineries">


          <Botton onClick={() => history.push('/Admin/Inventory/CreateWinery')} text={Translate("create", "es")} styles={{ width: '70%', margin: '4vw auto 2vw auto' }} />
          <InputSearch
            searchData={data => {
              setCodeName(data)
            }}
            isDrowMenu={false}
            placeholder={Translate("searchIn", "es") + Translate("wineries", "es").toLowerCase()}
            classNameContent="white" />
        </div>

        {(wineriesList.length ===0) ?
          <div>
            {
              codeName ==='' ?
                <div className={`text-warning`}>No hay Bodegas para mostrar</div> :
                <div className={`text-warning`}>La busqueda '{codeName}' no ha arrojado resultados</div>
            }
          </div> :
          <div className="content-list-wineries scroll-menu">
            {wineriesList.map((winery) =>
              <CardList
                key={winery._id}
                Icon={WineryIcon}
                style={cardStyle}
                onClick={() => { hadleClick(winery._id) }}
                hasOnClick={true}
                text={winery.name}

              />
            )}
          </div>}
      </div>
    </>
  );
};

export default Wineries;
